'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.geolocate = geolocate;

var _mapApi = require('./mapApi');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function geolocate(api) {
  return new _promise2.default(function (resolve) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var point = (0, _mapApi.isGMap)(api) ? new api.LatLng({ lat: position.coords.latitude, lng: position.coords.longitude }) : new api.Point(position.coords.longitude, position.coords.latitude);
      resolve(point);
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/shared/browserApi.js
// module id = 504
// module chunks = 0